import { Type } from "./Type";
import { TextFieldComponent } from "../components/Inputs/TextFieldComponent";
import { isFunction } from "lodash";

export const TextFieldFactory = (...args: any[]) => {
  let type = new Type({
    Component: TextFieldComponent
  });
  const props: any = {};

  if (args) {
    args.forEach(arg => {
      if (isFunction(arg)) {
        type.validators.push(arg);
      } else if (arg) {
        Object.assign(props, arg);
      }
    });
  }

  if (props && props.regex) {
    const re = new RegExp(props.regex);
    props.parse = (v: any) => {
      const newV = v.replace(re, "");
      if (newV === "") {
        return null;
      } else {
        return newV;
      }
    };
  }

  type.props = props;

  return type;
};
